import {prefixedExternalUrl} from '../../directives/external-link';
import _ from 'lodash';

class NewsController {
  constructor(NewsService, OfficesService, $window, $state) {
    'ngInject';
    Object.assign(this, {NewsService, $window, $state});
    // Load carousel items
    NewsService.carousel().then((carousel) => this.carouselItems = carousel);
    // load news
    NewsService.list().then((list) => {
      this.newsList = list;
      this.groupedNewsList = _(list).groupBy('dataPubblicazione').value();
    });
    // load categories
    OfficesService.list().then((list) => this.categoryList = list);
    // category is the name of the office, default is office with id 100
    this.selectedCategory = {label: 'TUTTE LE SEDI', id: ''};
    // banner image
    this.bannerImage = require('../../img/banner-default@2x.jpg');
    // true iff on tablet
    this.bigScreen = $window.innerWidth >= 768;
    // fallback image
    this.fallbackImage = require('../../img/article-cover.png');
  }

  selectNews(news) {
    console.debug('Going to news.item state', {officeId: news.id_sede, newsId: news.id_elemento});
    this.$state.go('news.item', {officeId: news.id_sede, newsId: news.id_elemento});
  }

  selectCategory(category) {
    this.selectedCategory = category;
    this.filterOpen = false;
  }

  openNews(url) {
    this.$window.open(prefixedExternalUrl(url), '_blank');
  }

  showCarousel() {
    return this.$state.current.name === 'news';
  }

  hideNewsList() {
    return !this.bigScreen && this.$state.current.name !== 'news';
  }
}

export default NewsController;



// WEBPACK FOOTER //
// ./client/app/components/news/news.controller.js